<template>
  <div class="content">
    <div class="detailContent">
        <h1>{{ lang == 'zh' ? newsDetailData.contentNameZhCn : (newsDetailData.contentNameEnUs ? newsDetailData.contentNameEnUs : newsDetailData.contentNameZhCn) }}</h1>
        <span class="subtitle">
          <span class="leftLine line" :class="$vuetify.breakpoint.mobile ? 'mobileLine':''"></span>{{ newsDetailData.contentDate | dateHandle }}<span class="rightLine line" :class="$vuetify.breakpoint.mobile ? 'mobileLine':''"></span>
        </span>
        <div ref="richText" id="richText" v-for="(item,index) in richTextList" :key="index">
          <p v-html="item"></p>
          <v-carousel 
            v-if="index != richTextList.length-1"
            class="carouselClass"
            cycle
            hide-delimiter-background
            :hide-delimiters="true"
            @change="newsCarouselChange"
            :show-arrows="false"
            height="100%"
          >
            <v-carousel-item 
              v-for="(item, i) in (lang == 'zh'? newsCarousel[0].picturesZhCn : newsCarousel[0].picturesEnUs ? newsCarousel[0].picturesEnUs : newsCarousel[0].picturesZhCn)" 
              :key="i"
              :src="item"
              cover
            >
            </v-carousel-item>
            <div class="footerCircle">
              <div v-for="(item, i) in (lang == 'zh'? newsCarousel[0].picturesZhCn : newsCarousel[0].picturesEnUs ? newsCarousel[0].picturesEnUs : newsCarousel[0].picturesZhCn)" :key="i" :class="i==carouselNewsIndex ? 'circle newActive' :'circle'"></div>
            </div>
          </v-carousel>
        </div>
        <!-- 底部的上下篇 -->
        <div class="footerNews">
          <div v-for="(item,index) in newsTitleList" :key="index" :class="index == 0 ? 'footerTitle' : 'footerTitle rightTitle'" @mouseenter="footerHoverTitle = true" @mouseleave="footerHoverTitle = false" @click="footerHoverTitle = true">
            <div v-if="item != ''" :class="$vuetify.breakpoint.mobile ? 'mobileIcon':''">
              <v-icon v-if="index == 0" :color="footerHoverTitle ? '#ce6171':''" >mdi-chevron-left</v-icon>
              <span @click="changeNews(item.contentId)">{{index == 0 ? '上一篇' : '下一篇'}}
                <span v-if="!$vuetify.breakpoint.mobile">：{{ lang == 'zh' ? item.contentNameZhCn : (item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn) }}</span>
              </span>
              <v-icon v-if="index != 0" :color="footerHoverTitle ? '#ce6171':''">mdi-chevron-right</v-icon>
            </div>
          </div>
          
        </div>
    </div>
  </div>
</template>

<script>
import newsApi from '../../api/news'
  export default {
    name: 'newsDetail',
    data: () => ({
      newsDetailData:{},
      carouselNewsIndex:'',
      newsCarousel:[],
      richTextList:[],
      newsTitleList:[],
      footerHoverTitle:false
    }),
    computed:{
        lang(){
            return this.$i18n.locale;
        }
    },
    filters:{
      dateHandle: (val)=>{
        let date = val?.substring(0,val.lastIndexOf('-')+3);
        return date?.replace(/-/g,'.')
      }
    },
    watch:{
      '$route.query.id'(val){
        this.getData();
      },
    },
    methods:{
        //切换新闻
        changeNews(id){
          this.$router.push({path:'/newsDetail',query:{id:id}})
        },
        newsCarouselChange(e){
          this.carouselNewsIndex = e;
        },
        async getData(){
          //获取当前新闻的详情
          let { data: newsDetailData } = await newsApi.getNewsDetail(`ac_${this.$route.query.id}`);
          if( newsDetailData ){
            this.newsCarousel =  [  { picturesZhCn:newsDetailData.picturesZhCn? newsDetailData.picturesZhCn.split(',') : [], picturesEnUs:newsDetailData.picturesEnUs? newsDetailData.picturesEnUs.split(',') : (newsDetailData.picturesZhCn? newsDetailData.picturesZhCn.split(',') : []) }  ];
            // this.richTextList = newsDetailData.contentZhCn.split('${_richText_carousr}')||[];
            if( newsDetailData.contentEnUs ){
              this.richTextList = newsDetailData.contentEnUs.split('${_richText_carousr}')
            }else{
              this.richTextList = newsDetailData.contentZhCn.split('${_richText_carousr}')
            }
            this.newsDetailData = newsDetailData;
          }else{
            this.newsCarousel = [];
            this.richTextList = [];
            this.newsDetailData = {};
          }
          //获取上下篇的标题
          let { data: newsListData } = await newsApi.getNewsList()
          let newsTitleListData = newsListData[0].contents;
          this.newsTitleList = [];
          newsTitleListData.forEach((item,index) => {
            if( item.contentId == this.$route.query.id ){
              if( index === 0 && index === newsTitleListData.length-1){
                
              }else if( index === 0 ){
                this.newsTitleList.push('',newsTitleListData[index+1])
              }else if( index === newsTitleListData.length-1 ){
                this.newsTitleList.push(newsTitleListData[index-1],'')
              }else{
                this.newsTitleList.push(newsTitleListData[index-1],newsTitleListData[index+1])
              }
            }
          });
        }
    },
    mounted(){
      this.getData();
    }
  }
</script>
<style lang="scss" scoped>
.content{
  padding: 0 15% 0 15%;
}
  .detailContent{
    
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .subtitle{
      margin: 20px;
      color: #c7c7c7;
      display: flex;
      .line{
        position: absolute;
        height: 1px;
        width: 30%;
        background: #c7c7c7;
        margin-top: 10px;
      }
      .mobileLine{
        width: 25%!important;
        margin-top: 8px!important;
      }
      .leftLine{
        left: 15%;
      }
      .rightLine{
        right: 15%;
      }
    }
    
  }
  .footerCircle{
    height: 30px;
    position: absolute;
    right: 20px;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .circle{
      width: 7px;
      height: 7px;
      margin-right: 3px;
      border-radius: 50%;
      background: #fff;
    }
    .newActive{
      border-radius: 30px;
      width: 20px;
      background: red;
      margin-top: 2px;
    }
  }
  .footerNews{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 50px;
    div{
      display: flex;
      align-items: center;
      span{
        font-size: 16px;
      }
    }
    .footerTitle{
      display: flex;
      align-items: center;
      width: 48%;
      cursor: pointer;
      :hover{
        color: #ce6171;
        text-decoration:underline;
      }
      .v-icon{
        transform: rotateX(45deg)!important;
        font-size: 20px;
      }
      
    }
    .rightTitle{
        justify-content: right;
      }
    .mobileIcon{
      .v-icon{
        font-size: 20px!important;
      }
    }
  }
  ::v-deep .v-image__image{
    background-size: contain!important;
  }
</style>
<style lang="scss">
  #richText{
    width: 100%;
    img{
      width: 100%!important;
    }
  }
</style>

